const Rating = () => {
  return (
    <div className="flex items-center space-x-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7881 3.2108C11.2365 2.13286 12.7635 2.13286 13.2119 3.2108L15.2939 8.21652L20.6979 8.64976C21.8617 8.74306 22.3336 10.1953 21.4469 10.9549L17.3296 14.4818L18.5875 19.7553C18.8584 20.8909 17.623 21.7884 16.6267 21.1799L12 18.354L7.37335 21.1799C6.37703 21.7884 5.14164 20.8909 5.41252 19.7553L6.67044 14.4818L2.55309 10.9549C1.66645 10.1953 2.13833 8.74306 3.30206 8.64976L8.70615 8.21652L10.7881 3.2108Z"
          fill="#E88532"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7881 3.2108C11.2365 2.13286 12.7635 2.13286 13.2119 3.2108L15.2939 8.21652L20.6979 8.64976C21.8617 8.74306 22.3336 10.1953 21.4469 10.9549L17.3296 14.4818L18.5875 19.7553C18.8584 20.8909 17.623 21.7884 16.6267 21.1799L12 18.354L7.37335 21.1799C6.37703 21.7884 5.14164 20.8909 5.41252 19.7553L6.67044 14.4818L2.55309 10.9549C1.66645 10.1953 2.13833 8.74306 3.30206 8.64976L8.70615 8.21652L10.7881 3.2108Z"
          fill="#E88532"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7881 3.2108C11.2365 2.13286 12.7635 2.13286 13.2119 3.2108L15.2939 8.21652L20.6979 8.64976C21.8617 8.74306 22.3336 10.1953 21.4469 10.9549L17.3296 14.4818L18.5875 19.7553C18.8584 20.8909 17.623 21.7884 16.6267 21.1799L12 18.354L7.37335 21.1799C6.37703 21.7884 5.14164 20.8909 5.41252 19.7553L6.67044 14.4818L2.55309 10.9549C1.66645 10.1953 2.13833 8.74306 3.30206 8.64976L8.70615 8.21652L10.7881 3.2108Z"
          fill="#E88532"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7881 3.2108C11.2365 2.13286 12.7635 2.13286 13.2119 3.2108L15.2939 8.21652L20.6979 8.64976C21.8617 8.74306 22.3336 10.1953 21.4469 10.9549L17.3296 14.4818L18.5875 19.7553C18.8584 20.8909 17.623 21.7884 16.6267 21.1799L12 18.354L7.37335 21.1799C6.37703 21.7884 5.14164 20.8909 5.41252 19.7553L6.67044 14.4818L2.55309 10.9549C1.66645 10.1953 2.13833 8.74306 3.30206 8.64976L8.70615 8.21652L10.7881 3.2108Z"
          fill="#E88532"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7881 3.2108C11.2365 2.13286 12.7635 2.13286 13.2119 3.2108L15.2939 8.21652L20.6979 8.64976C21.8617 8.74306 22.3336 10.1953 21.4469 10.9549L17.3296 14.4818L18.5875 19.7553C18.8584 20.8909 17.623 21.7884 16.6267 21.1799L12 18.354L7.37335 21.1799C6.37703 21.7884 5.14164 20.8909 5.41252 19.7553L6.67044 14.4818L2.55309 10.9549C1.66645 10.1953 2.13833 8.74306 3.30206 8.64976L8.70615 8.21652L10.7881 3.2108Z"
          fill="#E88532"
        />
      </svg>
    </div>
  );
};

export default Rating;
